import { camelCase } from 'lodash'
import { icons, statusToIcon } from '@/utils/mappers'
import { parseDate } from '@/utils/date'

/**
 * incidentMessage
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export default (data, labels) => {
    if (!data) {
        return null
    }
    return {
        title: data.title || '',
        date: data.date
            ? parseDate(data.date)
            : '',
        dateISOString: data.date || '',
        resolved: data.resolved || false,
        severity: data.severity || '',
        icon: data.resolved ? icons[statusToIcon['RESOLVED']] : icons[statusToIcon[data.severity]],
        systemAffected: data.systemAffected || '',
        tagLabel: labels[camelCase(data.systemAffected)] || '',
        downtimeDuration: data.downtimeDuration || 0,
        items: data.incidentStatusCollection?.items?.length
            ? data.incidentStatusCollection.items.filter(Boolean).map(el => {
                let icon
                if (el.status === 'IDENTIFIED') {
                    icon = data.severity ? icons[statusToIcon[data.severity]] : icons['warning-yellow']
                } else {
                    icon = icons[statusToIcon[el.status]]
                }
                return { ...el, title: labels[camelCase(el.status)], icon: icon, date: parseDate(el.date) }
            }).reverse()
            : []
    }
}
